import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { SupportChatStatus } from './types';

export interface InAppChatState {
  supportChatStatus: SupportChatStatus;
}

const initialState: InAppChatState = { supportChatStatus: SupportChatStatus.Offline };

const inAppChatServiceSlice = createSlice({
  name: 'Teamleader/Services/InAppChatService',
  initialState,
  reducers: {
    setSupportChatStatus(state, action: PayloadAction<SupportChatStatus>) {
      state.supportChatStatus = action.payload;
    },
  },
});

export const { setSupportChatStatus } = inAppChatServiceSlice.actions;
export default inAppChatServiceSlice.reducer;
